export default __webpack_public_path__ + "static/AlternativeEnergyOrdinance-71bd3346888e23d1449c64d034d1bd4e.jpg";